import { GET_INPUT_DATA } from "../actions/types";

const initialState = {
  irradiance_fixed_zero: null,
  irradiance_fixed_optimal: null,
  irradiance_inclined_optimal: null,
  irradiance_two_axis: null,
  windspeed: null,
  temperature: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_INPUT_DATA:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    default:
      return state;
  }
}
